import React from 'react';

var SvgPageHeartIcon = function SvgPageHeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 5.25c0-.69.56-1.25 1.25-1.25h2.25v3.75c0 .966.784 1.75 1.75 1.75h3.75v.5c0 .414.336.75.75.75s.75-.336.75-.75v-1.25c0-.199-.079-.39-.22-.53l-5.5-5.5c-.14-.141-.331-.22-.53-.22h-3c-1.519 0-2.75 1.231-2.75 2.75v9.5c0 1.519 1.231 2.75 2.75 2.75h1.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.69 0-1.25-.56-1.25-1.25v-9.5Zm7.94 2.75-2.94-2.94v2.69c0 .138.112.25.25.25h2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.25 12.074c-.878-.787-2.237-.765-3.087.068-.884.864-.884 2.272 0 3.137l2.213 2.165c.486.475 1.262.475 1.748 0l2.213-2.165c.884-.865.884-2.273 0-3.137-.85-.833-2.209-.855-3.087-.068Zm-2.038 1.14c.29-.285.77-.285 1.061 0l.453.442c.291.285.757.285 1.048 0l.453-.442c.291-.285.77-.285 1.061 0 .282.276.282.716 0 .992l-2.038 1.995-2.038-1.995c-.282-.276-.282-.716 0-.992Z"
  }));
};
SvgPageHeartIcon.displayName = "PageHeartIcon";

export { SvgPageHeartIcon as S };
